import { CanvasJSON, TRANSPARENT_PIXEL } from '@doer/frontend-components/creativity-editor';

const LOCKED = {
  selectable: false,
  evented: false,
  lockMovementX: true,
  lockMovementY: true,
  lockScalingX: true,
  lockScalingY: true,
  lockRotation: true,
  hasControls: false,
  hasBorders: false,
  objectCaching: true
};

const LOCAL_SLOT_CENTER = { x: 701, y: 510.5 };
const VISITOR_SLOT_CENTER = { x: 1539, y: 510.5 };
const SLOT_SIZE = { width: 500, height: 500 };

const COMMON = {
  version: '7.1.0',
  originX: 'left',
  originY: 'top',
  angle: 0,
  flipX: false,
  flipY: false,
  opacity: 1,
  visible: true,
  backgroundColor: '',
  fillRule: 'nonzero' as const,
  paintFirst: 'fill' as const,
  globalCompositeOperation: 'source-over' as const,
  skewX: 0,
  skewY: 0,
  stroke: null,
  strokeWidth: 0,
  strokeDashArray: null,
  strokeLineCap: 'butt' as const,
  strokeDashOffset: 0,
  strokeLineJoin: 'miter' as const,
  strokeUniform: false,
  strokeMiterLimit: 4
};

export const logoVsLogo1920x1080: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      ...COMMON,
      ...LOCKED,
      type: 'Polygon',
      pieceId: 'league-bg',
      left: 0,
      top: 0,
      scaleX: 1,
      scaleY: 1,
      points: [
        { x: 0, y: 0 },
        { x: 558, y: 0 },
        { x: 0, y: 1080 }
      ],
      fill: '#FFFFFF'
    },
    {
      ...COMMON,
      ...LOCKED,
      type: 'Polygon',
      pieceId: 'local-bg',
      left: 0,
      top: 0,
      scaleX: 1,
      scaleY: 1,
      points: [
        { x: 558, y: 0 },
        { x: 1380, y: 0 },
        { x: 822, y: 1080 },
        { x: 0, y: 1080 }
      ],
      fill: '#FFFFFF'
    },
    {
      ...COMMON,
      ...LOCKED,
      type: 'Polygon',
      pieceId: 'visitor-bg',
      left: 822,
      top: 0,
      scaleX: 1,
      scaleY: 1,
      points: [
        { x: 1380, y: 0 },
        { x: 1920, y: 0 },
        { x: 1920, y: 1080 },
        { x: 822, y: 1080 }
      ],
      fill: '#FFFFFF'
    },

    {
      ...COMMON,
      type: 'Image',
      pieceId: 'league-logo',
      imageFit: 'contain',
      imageBox: { width: 322, height: 381 },
      left: 35,
      top: 44,
      width: 1,
      height: 1,
      scaleX: 322,
      scaleY: 381,
      cropX: 0,
      cropY: 0,
      src: TRANSPARENT_PIXEL,
      crossOrigin: 'anonymous',
      filters: []
    },

    {
      ...COMMON,
      type: 'Image',
      pieceId: 'local-shield',
      originX: 'center',
      originY: 'center',
      imageFit: 'contain',
      imageBox: SLOT_SIZE,
      left: LOCAL_SLOT_CENTER.x,
      top: LOCAL_SLOT_CENTER.y,
      width: 1,
      height: 1,
      scaleX: 500,
      scaleY: 500,
      cropX: 0,
      cropY: 0,
      src: TRANSPARENT_PIXEL,
      crossOrigin: 'anonymous',
      filters: []
    },

    {
      ...COMMON,
      type: 'Image',
      pieceId: 'visitor-shield',
      originX: 'center',
      originY: 'center',
      imageFit: 'contain',
      imageBox: SLOT_SIZE,
      left: VISITOR_SLOT_CENTER.x,
      top: VISITOR_SLOT_CENTER.y,
      width: 1,
      height: 1,
      scaleX: 500,
      scaleY: 500,
      cropX: 0,
      cropY: 0,
      src: TRANSPARENT_PIXEL,
      crossOrigin: 'anonymous',
      filters: []
    }
  ]
};
